<ng-container *transloco="let t">
<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center">{{ t('portal.verification.verifyIncomeEmployment') }}</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()" [attr.aria-label]="t('common.close')"></button>
</div>

<div class="modal-body">
  @if (voeEnabled && plaidCheckEnabled && showProviderSelection) {
    <div class="provider-selection mb-4">
      <h6 class="fw-bold mb-3">{{ t('portal.verification.selectProvider') }}</h6>
      <div class="d-flex gap-3">
        <button
          class="btn"
          [class.btn-primary]="provider !== 'PlaidCheck'"
          [class.btn-outline-primary]="provider === 'PlaidCheck'"
          (click)="selectProvider(verificationProvider)">
          {{ verificationProvider === 'FormFree' ? 'AccountChek' : verificationProvider }}
        </button>
        <button
          class="btn"
          [class.btn-primary]="provider === 'PlaidCheck'"
          [class.btn-outline-primary]="provider !== 'PlaidCheck'"
          (click)="selectProvider('PlaidCheck')">
          Plaid Check
        </button>
      </div>
    </div>
  }

  @if (voeEnabled && loading && provider !== 'PlaidCheck') {
    <div class="card-px text-center py-20 my-10">
      <p class="text-gray-400 fs-4 fw-bold mb-10">{{ t('common.pleaseWait') }}</p>
      <i class="fas fa-circle-notch fa-4x fa-spin"></i>
    </div>
  }
  @if ((voeEnabled || plaidCheckEnabled) && errorMessage && provider !== 'PlaidCheck') {
    <div class="card-px text-center py-20 my-10">
      <i class="fas fa-exclamation-triangle fa-4x text-warning mb-4"></i>
      <h2 class="fs fw-bold mb-8">{{ t('portal.verification.unableToVerifyIncomeEmployment') }}</h2>
      <p class="text-gray-400 fs-4 fw-semibold mb-10">{{errorMessage}}</p>
      <button class="btn btn-secondary" (click)="activeModal.dismiss()">{{ t('common.close') }}</button>
    </div>
  }
  @if (voeEnabled && previousAttemptMessage && !loading && !errorMessage && provider !== 'PlaidCheck') {
    <div class="alert alert-warning d-flex align-items-start gap-3">
      <i class="fas fa-exclamation-triangle text-warning mt-1"></i>
      <span>{{previousAttemptMessage}}</span>
    </div>
  }
  @if (voeEnabled && thirdPartyEnrollmentWidget && !loading && !errorMessage && provider !== 'PlaidCheck') {
    <digital-income-employment-verification
      (complete)="onComplete()"
      (close)="onClose()"
      [applicationId]="applicationId"
      [borrowerId]="task.borrowerId"
      [taskId]="task.taskId"
      [borrowerVerificationOrderId]="borrowerVerificationOrderId"
      [provider]="provider"
      [thirdPartyEnrollmentWidget]="thirdPartyEnrollmentWidget"
      [usesOrdersApi]="usesOrdersApi">
    </digital-income-employment-verification >
  }

  @if (plaidCheckEnabled && provider === 'PlaidCheck') {
    <div class="plaid-check-section">
      @if (plaidCheckLoading) {
        <div class="card-px text-center py-20 my-10">
          <p class="text-gray-400 fs-4 fw-bold mb-10">{{ t('portal.verification.connectingToPlaid') }}</p>
          <i class="fas fa-circle-notch fa-4x fa-spin"></i>
        </div>
      }
      @if (errorMessage && !plaidCheckLoading) {
        <div class="card-px text-center py-20 my-10">
          <i class="fas fa-exclamation-triangle fa-4x text-warning mb-4"></i>
          <h2 class="fs fw-bold mb-8">{{ t('portal.verification.unableToVerifyIncomeEmployment') }}</h2>
          <p class="text-gray-400 fs-4 fw-semibold mb-10">{{errorMessage}}</p>
        </div>
      }
      @if (!plaidCheckLoading && !errorMessage) {
        <div class="consent-section p-4">
          <h6 class="fw-bold mb-3">{{ t('portal.verification.plaidCheckConsent') }}</h6>
          <p class="text-gray-600 fs-6 mb-4">
            {{ t('portal.verification.plaidIncomeConsentText') }}
          </p>
          <div class="form-check mb-4">
            <input
              type="checkbox"
              class="form-check-input"
              id="plaidCheckIncomeConsent"
              [(ngModel)]="plaidCheckConsentGiven">
            <label class="form-check-label" for="plaidCheckIncomeConsent">
              {{ t('portal.verification.consentToVerification') }}
            </label>
          </div>
          <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-secondary" (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
            <button
              class="btn btn-primary"
              [disabled]="!plaidCheckConsentGiven"
              (click)="startPlaidCheckVerification()">
              {{ t('portal.verification.continueWithPlaidCheck') }}
            </button>
          </div>
        </div>
      }
    </div>
  }

  @if (!voeEnabled && !plaidCheckEnabled) {
    <div class="card-px text-center py-20 my-10">
      <h2 class="fs fw-bold mb-8">{{ t('portal.verification.incomeNotAvailable') }}</h2>
      <p class="text-gray-400 fs-4 fw-semibold mb-10">{{ t('portal.verification.incomeNotAvailableMessage') }}</p>
    </div>
  }
</div>
</ng-container>
